import { useEffect } from 'react';
import { useLang } from '../context/LanguageContext';
import { SEO as SEO_META } from '../mock';

/**
 * Simple SEO helper — sets document.title and updates key meta tags per page.
 * Google renders JS so this works fine for indexing.
 */
const upsertMeta = (attr, key, content) => {
  if (typeof document === 'undefined') return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const SEO = ({ page }) => {
  const { lang } = useLang();
  useEffect(() => {
    const meta = (SEO_META[lang] && SEO_META[lang][page]) || SEO_META.en[page];
    if (!meta) return;
    document.title = meta.title;
    upsertMeta('name', 'description', meta.description);
    upsertMeta('property', 'og:title', meta.title);
    upsertMeta('property', 'og:description', meta.description);
    upsertMeta('property', 'og:locale', lang === 'cs' ? 'cs_CZ' : 'en_US');
    upsertMeta('name', 'twitter:title', meta.title);
    upsertMeta('name', 'twitter:description', meta.description);
    // Update html lang
    document.documentElement.lang = lang === 'cs' ? 'cs' : 'en';
  }, [lang, page]);
  return null;
};

export default SEO;
